import { Component, Inject, Optional, ViewEncapsulation } from '@angular/core';
import { NzMessageContainerComponent } from '../message/nz-message-container.component';
import { NzNotificationConfig, NZ_NOTIFICATION_CONFIG, NZ_NOTIFICATION_DEFAULT_CONFIG } from './nz-notification-config';

@Component({
  selector     : 'nz-notification-container',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div class="ant-notification" [style.top]="config.nzTop" [style.right]="config.nzRight">
      <nz-notification *ngFor="let message of messages; let i = index" [nzMessage]="message" [nzIndex]="i"></nz-notification>
    </div>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-notification {
  position: fixed;
  z-index: 1010;
  width: 335px;
  margin-right: 24px;
}
.ant-notification-topLeft,
.ant-notification-bottomLeft {
  margin-left: 24px;
  margin-right: 0;
}
.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,
.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationLeftFadeIn;
}
.ant-notification-notice {
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  background: #fff;
  line-height: 1.5;
  position: relative;
  margin-bottom: 10px;
  overflow: hidden;
}
.ant-notification-notice-message {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 4px;
  line-height: 20px;
  display: inline-block;
}
.ant-notification-notice-message-single-line-auto-margin {
  width: calc(335px - 16px * 2 - 24px - 48px - 100%);
  background-color: transparent;
  pointer-events: none;
  display: block;
  max-width: 4px;
}
.ant-notification-notice-message-single-line-auto-margin:before {
  content: '';
  display: block;
  padding-bottom: 100%;
}
.ant-notification-notice-description {
  font-size: 14px;
}
.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}
.ant-notification-notice-with-icon .ant-notification-notice-message {
  font-size: 16px;
  margin-left: 48px;
  margin-bottom: 4px;
}
.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}
.ant-notification-notice-icon {
  position: absolute;
  font-size: 32px;
  line-height: 32px;
}
.ant-notification-notice-icon-success {
  color: #00a854;
}
.ant-notification-notice-icon-info {
  color: #108ee9;
}
.ant-notification-notice-icon-warning {
  color: #ffbf00;
}
.ant-notification-notice-icon-error {
  color: #f04134;
}
.ant-notification-notice-close-x:after {
  font-size: 14px;
  content: "\\e633";
  font-family: "anticon";
  cursor: pointer;
}
.ant-notification-notice-close {
  position: absolute;
  right: 16px;
  top: 10px;
  color: rgba(0, 0, 0, 0.43);
  outline: none;
  text-decoration: none;
}
.ant-notification-notice-close:hover {
  color: #404040;
}
.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}
.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-notification-fade-enter,
.ant-notification-fade-appear {
  opacity: 0;
  animation-duration: 0.24s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-play-state: paused;
}
.ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-duration: 0.2s;
  animation-play-state: paused;
}
.ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}
.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}
@keyframes NotificationFadeIn {
  0% {
    opacity: 0;
    left: 335px;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    opacity: 0;
    right: 335px;
  }
  100% {
    right: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    opacity: 1;
    margin-bottom: 10px;
    padding-top: 16px;
    padding-bottom: 16px;
    max-height: 150px;
  }
  100% {
    opacity: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    max-height: 0;
  }
}
`
  ]
})
export class NzNotificationContainerComponent extends NzMessageContainerComponent {

  constructor(@Optional() @Inject(NZ_NOTIFICATION_DEFAULT_CONFIG) defaultConfig: NzNotificationConfig,
              @Optional() @Inject(NZ_NOTIFICATION_CONFIG) config: NzNotificationConfig) {
    super(defaultConfig, config);
  }

}
